import cx from "classnames";
import type { ReactElement, ReactNode } from "react";
import { Arrow, useHover, useLayer } from "react-laag";
import type { PlacementType } from "react-laag/dist/PlacementType";

interface TooltipProps {
  tooltip: ReactNode;
  background?: string;
  children: ReactElement;
  placement?: PlacementType;
  shouldShow?: boolean;
  childClassName?: string;
  tooltipClassName?: string;
  tooltipTag?: "p" | "div";
}

export function Tooltip({
  tooltip,
  background,
  children,
  placement,
  shouldShow = true,
  tooltipClassName,
  childClassName,
  tooltipTag = "p",
}: TooltipProps) {
  const [isOver, hoverProps] = useHover();

  const { triggerProps, layerProps, renderLayer, arrowProps } = useLayer({
    isOpen: isOver && shouldShow,
    auto: true,
    placement: placement || "bottom-center",
    triggerOffset: 6,
    overflowContainer: false,
  });

  const TooltipTag = tooltipTag;

  return (
    <>
      {shouldShow &&
        isOver &&
        renderLayer(
          <div {...layerProps} className="pointer-events-none z-50">
            <div
              role="tooltip"
              className={cx(
                background ? background : "bg-gray-800",
                "rounded px-3 py-2 shadow-md",
                tooltipClassName
              )}
            >
              <TooltipTag className="font-inter text-xs text-white">
                {tooltip}
              </TooltipTag>
              {/* @ts-expect-error react-laag types don't include newer React pointer event handlers */}
              <Arrow
                {...arrowProps}
                backgroundColor={background || "#2c3242"}
                size={5}
              />
            </div>
          </div>
        )}
      <span {...triggerProps} {...hoverProps} className={childClassName}>
        {children}
      </span>
    </>
  );
}
